module.exports = __webpack_public_path__ + "media/images/arrows/down-a0f660a9d90acd9994751400722683e2.svg";